<!-- 设置个人信息头像 -->
<template>
    <div class="avatar" :style="avatarStyle">
      <img :src="src" :alt="alt" class="avatar-img" />
    </div>
  </template>
  
  <script>
  export default {
    name: "Avatar",
    props: {
      src: {
        type: String,
        required: true
      },
      alt: {
        type: String,
        default: "Avatar"
      },
      size: {
        type: String,
        default: "100px"
      }
    },
    computed: {
      avatarStyle() {
        return {
          width: this.size,
          height: this.size,
          borderRadius: "50%"
        };
      }
    }
  };
  </script>
  
  <style scoped>
  .avatar {
    display: inline-block;
    overflow: hidden;
  }
  .avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  </style>
  